import { SpeechBubbleText } from '@dreamstack/feature-components/src/layout/Texts'
import type { BlockSpeechBubble } from '@dreamstack/payload/src/payload-types'
import type { FunctionComponent } from 'react'

const SpeechTriangle: FunctionComponent = () => (
  <div className="-translate-y-1/2 -rotate-45 left-[14px] w-0 h-0 border-b-accentroAquaLight-full border-b-[67px] border-l-[67px] border-l-transparent absolute" />
)
export const DefaultSpeechBubble: FunctionComponent<
  React.PropsWithChildren<{
    block: BlockSpeechBubble
  }>
> = ({ block }) => {
  const textField = block.text

  return (
    <div className="relative pb-px-48">
      <div className="bg-accentroAquaLight-full flex items-center flex-nowrap p-px-40 w-full">
        <SpeechBubbleText>&ldquo;{textField}&rdquo;</SpeechBubbleText>
      </div>
      <SpeechTriangle />
    </div>
  )
}
